module.exports = __webpack_public_path__ + "img/fondeg2.bbe168ad.jpg";